'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ payload, jwt }) => axios({
  method: 'post',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_COMMS_URL}/invites`,
  data: payload,
  timeout: 8000
})
